<div class="dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">{{ isEditMode ? 'Edit FAQ' : 'Create FAQ' }}</h4>
        <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close dialog">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 5L5 15M5 5L15 15" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>

    <!-- Dialog Content -->
    <form [formGroup]="faqForm" (ngSubmit)="onCreateFAQ()">
        <!-- Linked Tender -->
        <div class="form-group mb-4">
            <label for="linkedTenderId" class="form-label">
                Linked Tender <span class="required-asterisk">*</span>
            </label>
            <!-- Show readonly text input in edit mode -->
            <input
                *ngIf="isEditMode"
                type="text"
                id="linkedTenderId"
                class="form-control bg-light"
                formControlName="linkedTenderId"
                readonly>
            <!-- Show searchable select in create mode -->
            <app-searchable-select
                *ngIf="!isEditMode"
                [options]="tenderIds"
                [id]="'linkedTenderId'"
                [placeholder]="'Select the tender this FAQ is related to'"
                formControlName="linkedTenderId">
            </app-searchable-select>
            <div class="helper-text">{{ isEditMode ? 'Tender cannot be changed when editing' : 'Select the tender this FAQ is related to' }}</div>
            <div *ngIf="isFieldInvalid('linkedTenderId')" class="invalid-feedback">Linked Tender is required</div>
        </div>

        <!-- Question -->
        <div class="form-group mb-4">
            <label for="question" class="form-label">
                Question <span class="required-asterisk">*</span>
            </label>
            <textarea 
                id="question" 
                class="form-control" 
                formControlName="question"
                rows="3"
                placeholder="Enter the frequently asked question..."
                [class.is-invalid]="isFieldInvalid('question')"></textarea>
            <div class="helper-text">Be clear and concise with the question</div>
            <div *ngIf="isFieldInvalid('question')" class="invalid-feedback">Question is required</div>
        </div>

        <!-- Answer -->
        <div class="form-group mb-4">
            <label for="answer" class="form-label">
                Answer <span class="required-asterisk">*</span>
            </label>
            <textarea 
                id="answer" 
                class="form-control" 
                formControlName="answer"
                rows="5"
                placeholder="Provide a detailed answer to the question..."
                [class.is-invalid]="isFieldInvalid('answer')"></textarea>
            <div class="helper-text">Provide comprehensive and accurate information</div>
            <div *ngIf="isFieldInvalid('answer')" class="invalid-feedback">Answer is required</div>
        </div>


        <!-- Dialog Footer -->
        <div class="dialog-footer d-flex justify-content-end gap-2">
            <button type="button" class="btn cancel-btn" (click)="onCancel()">Cancel</button>
            <button *ngIf="!isEditMode" type="button" class="btn save-btn" (click)="onSave()">Save</button>
            <button type="submit" class="btn create-faq-btn">{{ isEditMode ? 'Edit FAQ' : 'Create FAQ' }}</button>
        </div>
    </form>
</div>

